import {translate} from "./utils/translate";
import mdtoast from './plugin/toast/mdtoast'
import toastSuccess from "../images/ico/toast-success.svg";
import toastWarning from "../images/ico/toast-warning.svg";
import toastDanger from "../images/ico/toast-danger.svg";
import toastInfo from "../images/ico/toast-info.svg";
import closeIco from "../images/ico/close-toast.svg";
import {forceNextTick, preloadImg} from "./utils";

preloadImg(toastDanger);
preloadImg(toastInfo);
preloadImg(toastWarning);
preloadImg(toastSuccess);
preloadImg(closeIco);

const types = {
    info: toastInfo,
    danger: toastDanger,
    warning: toastWarning,
    success: toastSuccess,
};

const htmlMessage = (title, content, typeClass) => {
    content = Array.isArray(content)
        ? content.map((msg) => `<div>${translate(msg)}</div>`).join("")
        : content
            ? `<div>${translate(content)}</div>`
            : ``;

    const contentDiv =
        content !== ""
            ? `
        <div class="toast-content mt-2">
            <div>${content}</div>
        </div>`
            : ``;

    return `
    <div class="toast-title ${typeClass}">
        ${translate(title)}
    </div>` + contentDiv;
};

const Toast = (() => {
    function showToast(settings) {
        const {
            title,
            content,
            type,
            interaction,
            duration,
            links,
            interactionTimeout,
            modal,
            position,
            action,
            contentTitle,
        } = settings;

        forceNextTick().then(() => {
            return mdtoast(htmlMessage(title, content, type), {
                action: action || function () { this.hide(); },
                modal: modal,
                duration: 1000000,
                interactionTimeout: interactionTimeout,
                actionIcoSrc: closeIco,
                statusIcoSrc: types[type],
                beforeClass: "toast-before " + type,
                messageClass: "d-flex flex-column justify-content-between py-20 ml-5",
                type: type,
                contentTitle,
                links: Array.isArray(links)
                    ? links.map((link) => ({
                        text: translate(link.text),
                        callback: link.callback,
                        contentSelector: link.contentSelector,
                    }))
                    : [],
                interaction,
            });
        })
    }

    return {
        toastSuccess: (settings) => showToast({ ...settings, type: "success" }),
        toastWarning: (settings) => showToast({ ...settings, type: "warning" }),
        toastError: (settings) => showToast({ ...settings, type: "danger" }),
        toast: (settings) => showToast({ ...settings, type: "info" }),
    };
})();

export default Toast;
